<template>
  <div class="viewitems">

    <v-layout row wrap class="mt-2">

      <div align="right" style="width:100%"  class="hidden-sm-and-up">
        <v-btn small round class="secondary" @click="$vuetify.goTo('#items', options)">Items for sale<v-icon>{{$vuetify.icons.decrease}}</v-icon></v-btn>
      </div>
      <v-flex v-if="picSrc" class="xl2 lg3 md4 sm6 xs12 pa-1">
          <v-img width="100%" max-height="80vh" contain :src="picSrc" />
      </v-flex>

      <v-flex class="md7 sm6 xs12">
        <v-layout column>
          <v-flex class="md2 sm6 xs12">
            <div class="subheading" style="text-align:left" v-html="biography"></div>
          </v-flex>
          <v-flex class="md6" id="items">
            <v-layout row wrap class="">
             <ItemTile
                v-for="(item, index) in itemsToShow"
                v-bind:item="item"
                v-bind:index="index"
                v-bind:name="item.name"
                v-bind:key="item.id"
                @itemClicked=itemClicked(item)
              ></ItemTile>
          </v-layout>
          <div v-if="nothingToSell" class="headline">
            There is nothing for sale yet.
          </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="text-xs-left">
      <v-flex class="sm6 xs12">
        Contact me &nbsp; <a class="accent--text" :href="mailto">{{email}}</a>
      </v-flex>

      <v-flex class="sm6 xs12 text-xs-right">
        <SocialMediaLinks :public_settings="public_settings" label="Around the web:"></SocialMediaLinks>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import ItemTile from './ItemTile.vue'
import SocialMediaLinks from '../common/SocialMediaLinks'

export default {
  name: 'ViewItems',
  components: {
    ItemTile, SocialMediaLinks,
  },
  props: {
  },
  computed: {
    ...mapState({
      public_settings: (state) => state.shopping.public_settings,
      categories: (state) => state.shopping.categories,
      items: (state) => state.shopping.items,
      selectedCategories: (state) => state.shopping.selectedCategories,
      biography: (state) => state.shopping.public_settings.biography,
      profilePic: (state) => state.shopping.public_settings.profilePic,
      aid: (state) => state.shopping.aid,
    }),
    options () {
        return {
          duration: 500,
          offset: 0,
          easing: 'easeInOutCubic'
        }
    },
    itemsToShow() {
      return this.items
      /* const allCats = []
      for (let i = 0; i < this.selectedCategories.length; i++) {
        allCats.push(this.selectedCategories[i].id)
      }

      const ALL_CATS_ID = '1'
      const itemsToShow = []
      for (let i = 0; i < this.items.length; i++) {
        const itemCategory = this.items[i].category
        if (allCats.includes(itemCategory) || allCats.includes(ALL_CATS_ID)) {
          itemsToShow.push(this.items[i])
        }
      }
      // console.log('ITEMS to SHOW:' + JSON.stringify(itemsToShow))
      return itemsToShow */
    },
    nothingToSell() {
      return this.itemsToShow.length === 0
    },
    picSrc() {
      if (this.profilePic && this.profilePic.downloadURL) {
        return this.profilePic.downloadURL
      } else {
        return null
      }
    },
    email() {
      return `${this.aid}@smartkidsmarket.com`
    },
    mailto() {
      return `mailto:${this.aid}@smartkidsmarket.com?subject=Mail from SmartKidsMarket`
    },
  },
  data() {
    return {
      right: null,
    }
  },
  mounted() {
    // this.loadCategories()
  },
  methods: {
    itemClicked(item) {
      // Set the current item
      this.$store.commit('shopping/setSelectedItem', item)

      // Load the item page
      this.$router.push({name: 'Item'})
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.viewitems {
  width: 100%;

}


</style>
